/**
 * Hook global : intercepte les clics sur les liens tubs.fr (data-tubs-url ou href contenant tubs.fr)
 * et envoie un événement d'analytics au backend en fire-and-forget (204).
 *
 * Utilisation :
 *   import useAffiliateTracker from "@/lib/useAffiliateTracker";
 *   useAffiliateTracker({ context: "model_detail", model_slug: "be-well/o665" });
 *
 * Contexte optionnel : les data-* de l'élément cliqué priment sur les props globales.
 */
import { useEffect } from "react";
import api from "@/lib/api";

const TUBS_HOST = "tubs.fr";

export default function useAffiliateTracker(defaults = {}) {
  useEffect(() => {
    const handler = (event) => {
      const link = event.target?.closest?.("a[href], [data-tubs-url]");
      if (!link) return;
      const targetUrl = link.getAttribute("data-tubs-url") || link.getAttribute("href");
      if (!targetUrl || !targetUrl.includes(TUBS_HOST)) return;

      // Prio: data-* > défauts du hook
      const payload = {
        target_url: targetUrl,
        partner: "tubs.fr",
        source_page: window.location.pathname,
        context: link.getAttribute("data-track-context") || defaults.context || "generic",
        model_slug: link.getAttribute("data-track-model") || defaults.model_slug || null,
        part_type: link.getAttribute("data-track-part-type") || defaults.part_type || null,
        brand: link.getAttribute("data-track-brand") || defaults.brand || null,
        part_ref: link.getAttribute("data-track-part-ref") || defaults.part_ref || null,
      };

      // Fire-and-forget — n'attend pas la réponse
      try {
        // Utiliser navigator.sendBeacon si dispo pour survivre à la navigation
        if (navigator.sendBeacon) {
          const blob = new Blob([JSON.stringify(payload)], { type: "application/json" });
          const base = api.defaults.baseURL || "";
          navigator.sendBeacon(`${base}/affiliate/track`, blob);
        } else {
          api.post("/affiliate/track", payload).catch(() => {});
        }
      } catch (_e) {
        /* silent */
      }
    };

    document.addEventListener("click", handler, true);
    return () => document.removeEventListener("click", handler, true);
  }, [defaults.context, defaults.model_slug, defaults.part_type, defaults.brand, defaults.part_ref]);
}
